import React from 'react'
import { Provider } from 'react-redux'
import { ConnectedRouter as Router } from 'connected-react-router'

import store from './modules'
import { history } from 'modules/store'
import GlobalStyle from 'views/globalStyles'
import RootComponent from 'views/RootComponent'
import { Sentry } from './sentry'
import analytics from 'analytics/initAnalytics'
import { AnalyticsProvider } from 'use-analytics'
import 'lib/frontend-shared/src/ui/date/DatePicker/styles.css'
import { HelmetContext, HelmetProps, useGTM } from '@agro-club/frontend-shared'
import env from 'env'
import { ThemeProvider } from 'styled-components'
import { theme } from 'theme/theme'
import { ConfigProvider } from 'antd'

const GTM: React.FC = () => {
  useGTM(env.GTM_ID)
  return null
}

class App extends React.Component {
  state = {
    helmet: { favicons: {} },
    updateHelmet: (props: HelmetProps) =>
      this.setState({ helmet: { ...props, favicons: props.favicons ? props.favicons : this.state.helmet.favicons } }),
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    Sentry.handleReactException(error, errorInfo, store.getState())
  }

  render() {
    return (
      <Provider store={store}>
        {/*ant design theme configuration. For changes related to styling as the already existing components*/}
        <ConfigProvider
          theme={{
            components: {
              Button: {
                fontWeight: '500',
                colorPrimary: '#20b02e',
                colorPrimaryBgHover: '#20b02eAA',
                colorPrimaryHover: '#20b02eAA',
              },
              Table: {
                headerBorderRadius: 0,
                cellPaddingInline: 24,
                headerBg: '#ffffff',
              },
            },
            token: {
              colorPrimary: '#20b02e',
              colorPrimaryBgHover: '#20b02eAA',
              colorPrimaryHover: '#20b02eAA',
              fontFamily: 'Montserrat, -apple-system, BlinkMacSystemFont, sans-serif',
              fontWeightStrong: 500,
            },
          }}
        >
          <GTM />
          <HelmetContext.Provider value={{ helmet: this.state.helmet, updateHelmet: this.state.updateHelmet }}>
            <AnalyticsProvider instance={analytics}>
              <ThemeProvider theme={theme}>
                <GlobalStyle />
                <Router history={history}>
                  <RootComponent />
                </Router>
              </ThemeProvider>
            </AnalyticsProvider>
          </HelmetContext.Provider>
        </ConfigProvider>
      </Provider>
    )
  }
}

export default App
